<template>
<div class="chapter">
<div class="inner_page">
<div class="tp1" epub:type="titlepage" id="_idContainer003"><div class="tp">
<p class="tp2"><img alt="title page" class="i300" src="image/1.jpg"/></p></div>
<p class="pubs"><span class="com-rorohiko-pagestaker-style CharOverride-1">v</span>Llewellyn Publications</p>
<p class="pubs">Woodbury, Minnesota</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title_Page.vue?4e46b93a